// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-box[data-v-0096df79]{border-radius:20px;border-top:none;border-right:none;border-left:none;margin:0 0 1em;padding:.4em 0 .4em .9em;color:#fff}.info-label[data-v-0096df79]{color:#fff;padding:1em;font-size:14px}.mdi[data-v-0096df79]:before{font-size:16px}", ""]);
// Exports
module.exports = exports;
